import { render, staticRenderFns } from "./PersTasks.vue?vue&type=template&id=4e0c9b28&"
import script from "./PersTasks.vue?vue&type=script&lang=js&"
export * from "./PersTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports